import { useState } from 'react';
import { pageWindow } from '../components/ui/Pagination';

export const LIST_PAGE_SIZE = 25;

/**
 * Pages a list the page already holds whole (the server sent every row), so it gets the same pager as every
 * other list. The one owner of that slicing: Vendors, Clients, the credit note register, users and item
 * groups all use it. A page past the end (a delete, a filter) is clamped by `pageWindow`, never left empty.
 */
export function usePagedRows<T>(rows: T[], pageSize: number = LIST_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const win = pageWindow(page, pageSize, rows.length);
  return {
    visible: rows.slice(win.from - 1 < 0 ? 0 : win.from - 1, win.to),
    /** The row number of the first visible row, for a "#" column. */
    first: win.from,
    page: win.page,
    setPage,
    pageSize,
    total: rows.length,
  };
}
